import { ICintorinConfig } from "./common/interfaces";
import { dismissModal, openModal } from "./common/utilities";
import { addAuthorization } from "./iam";
import { reloadCv } from "./spomienky";

declare const CintorinConfig: ICintorinConfig;

interface INewPhotoRequest {
    deceasedId: number,
    filePath?: string,
    instanceOf?: number,
    shouldAttachToCv?: boolean
}

interface IEditCvPhotosRequest {
    deceasedId: number,
    photoIds: number[]
}

export function attachPhotoEventHandlers() {
    document.querySelector(".add-photo")?.addEventListener("click", openAddPhotoModal);
    document.querySelectorAll(".photo-actions [data-action='delete']").forEach(b => b.addEventListener("click", deletePhoto));
    document.querySelectorAll(".photo-actions [data-action='edit']").forEach(b => b.addEventListener("click", openEditPhotoModal));

    document.querySelector("#editPhotoModal .btn-close")?.addEventListener("click", function () { dismissModal("#editPhotoModal"); });
    document.querySelector("#addPhotoModal .btn-close")?.addEventListener("click", function () { dismissModal("#addPhotoModal"); });
    document.getElementById("addPhotoButton")?.addEventListener("click", handleAddPhotoButtonClick);
    document.getElementById("saveEditedPhotoButton")?.addEventListener("click", savePhotoEdits);
    (document.getElementById("editPhotoFileForm") as HTMLFormElement)?.addEventListener("submit", (e) => e.preventDefault());

    attachCvPhotoEventHandlers();
}

export function attachCvPhotoEventHandlers() {
    document.getElementById("addCvPhotosButton")?.addEventListener("click", openAddPhotoModal);
    document.querySelectorAll(".edit-cv-photo").forEach(e => e.addEventListener("click", openEditPhotoModal));
    document.querySelector(".add-cv-photo")?.addEventListener("click", openAddPhotoModal);
}

function openAddPhotoModal() {
    let attachCv = true;
    if (this?.classList.contains("add-photo")) { 
        attachCv = false;
    }
    document.querySelectorAll("#addPhotoModal .modal-body > div").forEach(e => (e as HTMLElement).style.display = "");
    let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
    let additionalParam = (attachCv ? "&cv=1" : "");
    fetch(CintorinConfig.baseUrl+"/api/chronicle/htmlGetNewPhotoForm.php?deceasedId="+deceasedId+additionalParam,  {
        method: "GET",
        headers: addAuthorization(new Headers({'Content-Type': 'application/urlencoded'}))
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(resultHtml => {
        if (resultHtml) {
            document.querySelector("#addPhotoModal .modal-body").innerHTML = resultHtml;
            document.getElementById("filePath")?.addEventListener("input", handleFilePathInput);
            if (attachCv) {
                document.querySelectorAll("#newPhotoList .photo-grid-item").forEach(e => e.addEventListener("click", handleCvPhotoItemClick));
            } else {
                document.querySelectorAll("#newPhotoList .photo-grid-item").forEach(e => {
                    if (!e.classList.contains("disabled")) {
                        e.addEventListener("click", handleAddExistingPhotoItemClick);
                    }
                });
            }
            validateNewPhotoForm();
        }
        openModal("#addPhotoModal");
    });
}

function handleFilePathInput() {
    let path = this.value;
    if (path != "" && document.getElementById("selectedPhotoId")) {
        document.querySelectorAll("#newPhotoList .photo-grid-item").forEach(e => e.classList.remove("selected"));
        (document.getElementById("selectedPhotoId") as HTMLInputElement).value = ""; 
    }
    validateNewPhotoForm();
}

function handleAddExistingPhotoItemClick() {
    document.querySelectorAll("#newPhotoList .photo-grid-item").forEach(e => e.classList.remove("selected"));
    let newId = this.getAttribute("data-foto-id");
    let selectedIdInput = document.getElementById("selectedPhotoId") as HTMLInputElement;
    if (selectedIdInput.value == newId) {
        selectedIdInput.value = "";
    } else {
        selectedIdInput.value = newId;
        this.classList.add("selected");
        (document.getElementById("filePath") as HTMLInputElement).value = "";
    }
    validateNewPhotoForm();
}

function extractFilename(path:string) { // prevzate z https://html.spec.whatwg.org/multipage/input.html#fakepath-srsly
    if (path.substring(0, 13) == "C:\\fakepath\\")
      return path.substring(12); // modern browser
    var x;
    x = path.lastIndexOf('/');
    if (x >= 0) // Unix-based path
      return path.substring(x+1);
    x = path.lastIndexOf('\\');
    if (x >= 0) // Windows-based path
      return path.substring(x+1);
    return path; // just the filename
}

function handleAddPhotoButtonClick() {
    let request:INewPhotoRequest = {
        deceasedId: +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id")
    };
    let existingPhotoId = +(document.getElementById("selectedPhotoId") as HTMLInputElement)?.value;
    let filePath = extractFilename((document.getElementById("filePath") as HTMLInputElement).value);
    let input = document.getElementById("shouldAttachToCv") as HTMLInputElement;
    if (input && input.value == "1") {
        request.shouldAttachToCv = true;
    }

    if (filePath) {
        request.filePath = filePath;
        addPhotoEntry(request, true);
    } else if (existingPhotoId) {
        request.instanceOf = existingPhotoId;
        addPhotoEntry(request, false);
    } else if (request.shouldAttachToCv) {
        let photoIds:number[] = [];
        document.querySelectorAll("#newPhotoList .photo-grid-item").forEach(e => {
            if (e.classList.contains("selected") && e.hasAttribute("data-foto-id")) {
                photoIds.push(+e.getAttribute("data-foto-id"));
            }
        });
        saveCvPhotoChanges({
            deceasedId: request.deceasedId,
            photoIds: photoIds
        });
    }
}

function handleCvPhotoItemClick() {
    if (this.classList.contains("selected")) {
        this.classList.remove("selected");
    } else {
        this.classList.add("selected");
    }
}

function saveCvPhotoChanges(request: IEditCvPhotosRequest) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/updateCvPhotos.php",  {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify(request)
    }).then(response => {
        if (response.ok && response.status == 200) {
            dismissModal("#addPhotoModal");
            reloadCv();
            reloadPhotos();
        } else {
            openModal("#genericErrorModal");
        } // todo: ohandlovat errory
    })
}

function validateNewPhotoForm() {
    let uploadFile = (document.getElementById("filePath") as HTMLInputElement).files;
    let uploadFileNotAvailable = true;
    document.getElementById("fileSizeErrorMessage").style.display = "none";
    if (uploadFile.length > 0) {
        if (uploadFile[0].size < 10 * 1024 * 1024) { // 10MB
            uploadFileNotAvailable = false;
        } else {
            document.getElementById("fileSizeErrorMessage").style.display = "";
        }
    }
    let existingPhotosValid = false;
    if ((document.getElementById("shouldAttachToCv") as HTMLInputElement)?.value == "1") {
        existingPhotosValid = document.querySelectorAll("#newPhotoList .photo-grid-item").length > 0;
    } else {
        existingPhotosValid = (document.getElementById("selectedPhotoId") as HTMLInputElement)?.value != "";
    }
    (document.getElementById("addPhotoButton") as HTMLButtonElement).disabled = uploadFileNotAvailable && !existingPhotosValid;
}

function reloadPhotos() {
    let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
    fetch(CintorinConfig.baseUrl+"/api/chronicle/htmlGetChroniclePhotos.php?deceasedId="+deceasedId,  {
        method: "GET",
        headers: addAuthorization(new Headers({'Content-Type': 'application/urlencoded'}))
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(resultHtml => {
        if (resultHtml) {
            document.getElementById("kronika-foto-tab").innerHTML = resultHtml;
            updatePhotoCount();
            document.querySelector(".add-photo")?.addEventListener("click", openAddPhotoModal);
            document.querySelectorAll(".photo-actions [data-action='delete']").forEach(b => b.addEventListener("click", deletePhoto));
            document.querySelectorAll(".photo-actions [data-action='edit']").forEach(b => b.addEventListener("click", openEditPhotoModal));
        }
    });
}

function addPhotoEntry(request: INewPhotoRequest, isNewPhoto: boolean) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/addPhotoEntry.php",  {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify(request)
    }).then(response => {
        if (response.ok && response.status == 201) {
            return response.json();
        }
    }).then(result => {
        if (result && result.photoId) {
            if (isNewPhoto) {
                uploadPhoto(result.photoId);
            } else {
                reloadPhotos();
                reloadCv();
            } 
            (document.getElementById("filePath") as HTMLInputElement).value = "";
            if (document.getElementById("selectedPhotoId")) {
                (document.getElementById("selectedPhotoId") as HTMLInputElement).value = "";
            }
            validateNewPhotoForm();
            dismissModal("#addPhotoModal");
        } else {
            openModal("#genericErrorModal");
        }
    })
}

function uploadPhoto(photoId: number) {
    document.querySelector(".upload-progress").classList.remove("alert", "alert-danger");
    document.querySelector("#uploadProgressBar").classList.remove("bg-danger");
    document.querySelector("#uploadProgressBar").classList.add("progress-bar-striped", "progress-bar-animated");
    document.getElementById("uploadProgressBar").style.width = "0";
    document.getElementById("uploadProgressBar").style.transition = "";
    (document.querySelector(".progress-label") as HTMLElement).style.display = "";
    (document.querySelector(".progress-error") as HTMLElement).style.display = "none";
    (document.querySelector("#kronika-foto-tab .upload-progress") as HTMLElement).style.display = "";
    document.querySelector(".add-photo").classList.add("disabled");

    let request = new XMLHttpRequest();
    request.open("POST", CintorinConfig.baseUrl+"/api/chronicle/uploadPhoto.php?photoId="+photoId);
    request.upload.addEventListener("progress", (e) => {
        let percent = Math.floor(100*e.loaded / e.total);
        document.getElementById("uploadProgressBar").setAttribute("aria-valuenow", percent+"");
        document.getElementById("uploadProgressBar").innerText = percent+"%";
        document.getElementById("uploadProgressBar").style.width = percent+"%";
    });
    request.addEventListener("readystatechange", () => {
        if (request.readyState == 4) {
            if (request.status == 200) {
                reloadPhotos();
                reloadCv();
            } else {
                document.querySelector(".upload-progress").classList.add("alert", "alert-danger");
                document.querySelector("#uploadProgressBar").classList.add("bg-danger");
                document.querySelector("#uploadProgressBar").classList.remove("progress-bar-striped", "progress-bar-animated");
                document.getElementById("uploadProgressBar").innerText = "";
                document.getElementById("uploadProgressBar").style.transition = "width 0s";
                document.getElementById("uploadProgressBar").style.width = "100%";
                (document.querySelector(".progress-label") as HTMLElement).style.display = "none";
                (document.querySelector(".progress-error") as HTMLElement).style.display = "";
                document.querySelector(".add-photo").classList.remove("disabled");
            }
        }
    });
    let formData = new FormData(document.getElementById("newPhotoFileForm") as HTMLFormElement);
    let authHeader = addAuthorization(new Headers());
    request.setRequestHeader("Authorization", authHeader.get("Authorization"));
    request.send(formData);
}

function deletePhoto() {
    let photoId = +this.parentElement.getAttribute("data-photo-id");
    fetch(CintorinConfig.baseUrl+"/api/chronicle/deletePhoto.php", {
        "method": "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify({
            photoId: photoId
        })
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (result && result.success) {
            reloadPhotos();
            reloadCv();
        } else {
            openModal("#genericErrorModal");
        }
    })
}

function updatePhotoCount() {
    let deceasedId = +document.getElementById("chronicleSelectedPerson").getAttribute("data-deceased-id");
    let count = 0;
    document.querySelectorAll("#kronika-foto-tab .card-img-top").forEach(() => count++);
    document.getElementById("numPhoto").innerText = count+"";
    if (count > 0) {
        document.querySelector("#chroniclePersonDropdown li[data-deceased-id='"+deceasedId+"'] .icon-photos")?.classList.add("icon-active");
        document.querySelector("#chronicleSelectedPerson[data-deceased-id='"+deceasedId+"'] .icon-photos")?.classList.add("icon-active");
    } else {
        document.querySelector("#chroniclePersonDropdown li[data-deceased-id='"+deceasedId+"'] .icon-photos")?.classList.remove("icon-active");
        document.querySelector("#chronicleSelectedPerson[data-deceased-id='"+deceasedId+"'] .icon-photos")?.classList.remove("icon-active");
    }
}

function openEditPhotoModal() {
    let photoId = +this.parentElement.getAttribute("data-photo-id");
    fetch(CintorinConfig.baseUrl+"/api/chronicle/getPhotoDetails.php?photoId="+photoId, {
        "method": "GET",
        headers: addAuthorization(new Headers())
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (result) {
            (document.getElementById("editedPhotoPreview") as HTMLImageElement).src = CintorinConfig.baseUrl+"/api/chronicle/getChroniclePhotoThumbnail.php?photoId="+photoId;
            document.getElementById("fileSizeSpan").innerText = result.dimensions+", "+result.size;
            (document.getElementById("photoAuthor") as HTMLInputElement).value = result.author;
            (document.getElementById("photoDescription") as HTMLTextAreaElement).value = result.description;
            if (document.getElementById("photoInCv")) { // nemusi byt ak nie som spravcom kroniky
                (document.getElementById("photoInCv") as HTMLInputElement).checked = result.showInCv;
            }
            (document.getElementById("editedPhotoId") as HTMLInputElement).value = result.photoId;
            openModal("#editPhotoModal");
        } else {
            (document.getElementById("editedPhotoId") as HTMLInputElement).value = "";
            openModal("#genericErrorModal"); //todo: zjednotit chybove hlasenia a doriesit lokalizaciu hlasok
        }
    })
}

function savePhotoEdits() {
    let payload:any = {
        photoId: +(document.getElementById("editedPhotoId") as HTMLInputElement).value,
        author: (document.getElementById("photoAuthor") as HTMLInputElement).value,
        description: (document.getElementById("photoDescription") as HTMLTextAreaElement).value
    };
    if (document.getElementById("photoInCv")) {
        payload.showInCv = ((document.getElementById("photoInCv") as HTMLInputElement)?.checked ?? false);
    }
    fetch(CintorinConfig.baseUrl+"/api/chronicle/editPhotoDetails.php",{
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify(payload)
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (result && result.success) {
            reloadPhotos();
            reloadCv();
        } else {
            openModal("#genericErrorModal");
        }
        dismissModal("#editPhotoModal");
    })
}